import { Component, computed, inject } from '@angular/core';
import { LoadingService } from '../loading.service';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  host: {
    '[class]': 'class()'
  }
})
export class LoadingSpinnerComponent {
  isLoading = inject(LoadingService).isLoading;
  class=computed(()=> this.isLoading() ? 'flex' : 'hidden')
}
